export default __webpack_public_path__ + "static/media/elearn.beb9554f.png";